import React from 'react';
import LeftContent from '../OTPPage/Children/leftContent';
import ForgotCard from './childrens/forgotCard';
import '../OTPPage/index.scss';

const ForgotPwd = () => {

 return <div className="public_content">
    <div className="left_wrap"><LeftContent /></div>
    <div className="right_wrap"><ForgotCard /></div>
 </div>    
};
export default ForgotPwd;